import { Component, OnInit, ViewChild } from '@angular/core';
import { DataService } from 'src/app/services/data.service';

@Component({
  selector: 'app-onlineclientportalpage',
  templateUrl: './onlineclientportalpage.component.html',
  styleUrls: ['./onlineclientportalpage.component.css']
})
export class OnlineclientportalpageComponent implements OnInit {

  constructor(public ds: DataService) { }

  ngOnInit() {
  }
}
